import * as React from 'react'
import { useController } from 'react-hook-form'
import Layout from '../components/controls/Layout'

export default function Tags({ props, options }) {
    const { name, label, description } = props
    const { field } = useController({ name })
    const { onChange, value: tags, ...input } = field
    const handleChange = React.useCallback(
        event => {
            onChange([event.target.value])
        },
        [onChange]
    )

    return (
        <Layout name={name} description={description}>
            <label>{label}</label>
            <div>
                {Object.entries(options.options).map(([value, display]) => (
                    <label key={value}>
                        <input
                            type="radio"
                            value={value}
                            onChange={handleChange}
                            checked={tags?.includes(value)}
                            {...input}
                        />
                        {display}
                    </label>
                ))}
            </div>
        </Layout>
    )
}
